module.exports = __webpack_public_path__ + "media/images/application/template/logos/tata-steel-1503551a3072dbbc99d6448180a22ef1.png";